import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


// Paste your config here
const firebaseConfig = {
 apiKey: "AIzaSyCtNbnicDhuMjbA7eu8bG-te9d-Z0P_RQs",
  authDomain: "arocoiris-tech.firebaseapp.com",
  projectId: "arocoiris-tech",
  storageBucket: "arocoiris-tech.firebasestorage.app",
  messagingSenderId: "73014973192",
  appId: "1:73014973192:web:85b8b9662f4260efc792bd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
 const storage = getStorage(app);
export { db,storage };